import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import { useGetBusinessSettings } from '~/hooks/apis/business-traveller/useBusinessSettings';

import BusinessSettingTabContent from './BusinessSettingTabContent';

export default function DefaultBusinessSettingPanel() {
  const { data: settings = {}, isFetching, error } = useGetBusinessSettings();

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <BusinessSettingTabContent initialSettings={settings} error={error} />;
}
